// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3EQog","tab":"tab__M3Zbk","active":"active__13Bxs"};